import { Link, Route } from "react-router-dom";
import Dashboard from "./Dashboard";
import Layout from "./Layout";
import RequestForQuotations from "./pages/RequestForQuotations";
// import { loadQuotation, loadQuotations } from "./apis/requestForQuotationAPI";
// import QuotationChanges from "./pages/QuotationChanges";
import PurchaseOrders from "./pages/PurchaseOrders";
import PurchaseOrderChanges from './pages/PurchaseOrderChanges';
import { loadPOTransfer, loadPOTransfers, loadProchaseOrder, loadPurchaseOrders, loadQuotations } from "./apis/purchaseOrdersAPI";
import Products from "./pages/Products";
import { loadProduct, loadProducts } from "./apis/productAPI";
import ProductChanges from "./pages/ProductChanges";
import Contacts from "./pages/Contacts";
import { loadContact, loadContacts } from "./apis/contactsAPI";
import ContactChanges from "./pages/ContactChanges";
import ProductCategories from "./pages/ProductCategories";
import ProductCategoryChanges from "./pages/ProductCategoryChanges";
import { loadProductCategories, loadProductCategory } from "./apis/productCategoriesAPI";
import PurchaseOrderTransfers from "./pages/PurchaseOrderTransfers";
import PurchaseOrderTransferChanges from "./pages/PurchaseOrderTransferChanges";
import VendorLists from "./pages/VendorLists";
import { loadVendorList, loadVendorLists } from "./apis/vendorListAPI";
import VendorListChanges from "./pages/VendorListChanges";
import Attributes from "./pages/Atrributes";
import { loadAttribute, loadAttributes } from "./apis/attributeAPI";
import AttributeChanges from "./pages/AttributeChanges";




const purchaseRouter = () => (
  <Route path="/purchase" element={<Layout />} handle={{ crumb: () => <Link to={'/purchase'}>Purchase</Link>}}>
    <Route index element={<RequestForQuotations />} loader={loadQuotations}/>
    <Route path="request-for-quotation" element={<RequestForQuotations />} loader={loadQuotations} handle={{ crumb: () => <Link>Request For Quotation</Link>}} />
    <Route path="request-for-quotation/:action" element={<PurchaseOrderChanges />} loader={params => loadProchaseOrder(params.params.action)} handle={{ crumb: (data) =><span><Link to={'/purchase/request-for-quotation'}>Request For Quotation</Link> / {data.purchaseOrder?.number}</span>}}/>
    <Route path="purchase-orders" element={<PurchaseOrders />} loader={loadPurchaseOrders} handle={{ crumb: () => <Link>Purchase Orders</Link>}} />
    <Route path="purchase-orders/:action" element={<PurchaseOrderChanges />} loader={params => loadProchaseOrder(params.params.action)} handle={{crumb: (data) => <Link to={'/purchase/purchase-orders'}>PURCHASE ORDERS</Link>}} />
    <Route path="purchase-orders/:id/transfers" element={<PurchaseOrderTransfers />} loader={params => loadPOTransfers(params.params.id)} handle={{crumb: (data) => console.log(data)}} />
    <Route path="purchase-orders/:id/transfers/:action" element={<PurchaseOrderTransferChanges />} loader={params => loadPOTransfer(params.params.action, params.params.id)} handle={{crumb: (data) => console.log(data)}} />
    <Route path="products" element={<Products />} loader={loadProducts} handle={{ crumb: () => <Link>Products</Link>}} />
    <Route path="products/:action" element={<ProductChanges />} loader={params => loadProduct(params.params.action)} handle={{ crumb: (data) => <span><Link to={'/purchase/products'}>Products</Link> / {data.product?.name}</span>}} />
    <Route path="vendors" element={<Contacts />} loader={loadContacts} />
    <Route path="vendors/:action" element={<ContactChanges />} loader={params => loadContact(params.params.action)} />
    <Route path="attributes" element={<Attributes />} loader={loadAttributes} />
    <Route path="attributes/:action" element={<AttributeChanges />} loader={params => loadAttribute(params.params.action)} />

    <Route path="product-categories" element={<ProductCategories />} loader={loadProductCategories} />
    <Route path="product-categories/:action" element={<ProductCategoryChanges />} loader={params => loadProductCategory(params.params.action)} />
    <Route path="vendorlists" element={<VendorLists />} loader={loadVendorLists} />
    <Route path="vendorlists/:action" element={<VendorListChanges />} loader={params => loadVendorList(params.params.action)} />
  </Route>
);


export default purchaseRouter;